import {lazy} from "react";
import {connect} from "react-redux";
import {Navigate, Outlet, Route, Routes} from "react-router-dom";
import {
  getUser,
  isAuthenticated,
  isLoading,
} from "./store/selectors/AuthSelectors";
import LockScreen from "./jsx/pages/LockScreen";
import Error400 from "./jsx/pages/Error400";
import Error403 from "./jsx/pages/Error403";
import Error404 from "./jsx/pages/Error404";
import Error500 from "./jsx/pages/Error500";
import Error503 from "./jsx/pages/Error503";
import {
  allroutes,
  clientAllroutes,
  MainLayout,
  Techallroutes,
} from "./jsx/index";
import Loader from "./jsx/components/shared/Loader";
import SocialAuth from "./jsx/pages/auth/socialsAuth";
import {accountStatus, userRoleList} from "./utils/constants";
import Verif from "./jsx/pages/auth/verif";
import AppProfile from "./jsx/components/AppsMenu/AppProfile/AppProfile";
import ProfilePage from "./jsx/pages/auth/profilePage";
import BancDetails from "./jsx/pages/auth/bancs";
import PasswordPage from "./jsx/pages/auth/password";
import PageAjoutAnnonce from "./jsx/pages/annonce/AjoutAnnonce";
import AnnonceStepper from "./jsx/pages/annonce/stepperPage";
import PageUpdateAnnonce from "./jsx/pages/annonce/UpdateAnnonce";
import FooterLogin from "./jsx/layouts/FooterLogin";
import SideBg from "./jsx/components/shared/loginSideBg";
import ModifProfilePage from "./jsx/pages/auth/ModifierProfile";
import PaymentSheet from "./jsx/components/payments/stripePayment";
import CompletePage from "./jsx/components/payments/completePage";
import PaymentPage from "./jsx/components/payments";
import RecherchePrestataires from "./jsx/pages/prestataires";
import GeneralConditionPage from "./jsx/pages/GeneralCondition";
import PrivacyPolicyPage from "./jsx/pages/PrivacyPolicy";
import ClientContainer from "./jsx/layouts/container/clientContainer";
import NotificationPage from "./jsx/pages/notification";
import AccountSettingPage from "./jsx/pages/AccountSettings";
import PageAide from "./jsx/pages/Aide";
import TechContainer from "./jsx/layouts/container/techContainer";
import InterventionPaymentPage from "./jsx/components/payments/InterventionPayement";
import TicketsPage from "./jsx/pages/tickets";
import TicketPage from "./jsx/pages/tickets/TicketPage";
import RedirectMobileModal from "./jsx/components/shared/RedirectMobileModal";
import DeepLinkRedirector from "./jsx/components/shared/deepLinkRedirector";
import {getStoredAuthToken} from "./utils/authToken";

const TelVerification = lazy(() =>
  import("./jsx/components/shared/telVerification")
);

const SignUp = lazy(() => import("./jsx/pages/Registration"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  });
});
const Index = lazy(() => import("./jsx/index"));

const RoleRoute = ({roles}) => {
  // const {getUser} = useAuthContext();
  if (!roles || !roles.length) {
    return <Outlet />;
  }

  /* if (!roles.includes(getUser.selectedRole)) {
    return <Navigate to={"/"} replace={true} />;
  } */
  return <Outlet />;
};

/* RoleRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
};
 */
const ProtectedRoute = ({isAuthenticated, isLoading, user, isProfile}) => {
  const token = getStoredAuthToken();
  // const {isAuthenticated} = useAuthContext();

  if (isLoading) {
    return <Loader />;
  }

  if (!token || !isAuthenticated) {
    return <Navigate to={"/login"} replace />;
  }

  if (
    user.selectedRole === userRoleList.TECHNICIAN &&
    (user?.Technician?.status !== accountStatus.VALID || !user.Technician) &&
    !isProfile
  ) {
    return <Navigate to={"/verification"} replace />;
  }

  return (
    <>
      <DeepLinkRedirector />
      <Outlet />
    </>
  );
};

const AuthRoute = ({isAuthenticated, isLoading}) => {
  const token = getStoredAuthToken();
  // const {isAuthenticated} = useAuthContext();

  // if (token && !!isAuthenticated) {
  //   return;
  // }
  if (isLoading) {
    return <Loader />; // Show loader while checking auth status
  }
  return !!isAuthenticated && !!token ? (
    <Navigate to={""} replace />
  ) : (
    <div className="min-h-screen flex flex-col">
      <DeepLinkRedirector />
      <div className="flex-grow">
        <div className="login-wrapper">
          <SideBg />

          <div className="login-aside-right">
            <Outlet />
          </div>
        </div>
      </div>
      <FooterLogin />
    </div>
  );
};

const RouterComponent = ({isAuthenticated, isLoading, user}) => {
  const hasAuthenticatedSession = Boolean(
    isAuthenticated && getStoredAuthToken(),
  );

  return (
    <Routes>
      {hasAuthenticatedSession ? (
        <Route element={<MainLayout user={user} />}>
          <Route
            path="/politique-de-confidentialite"
            element={<PrivacyPolicyPage embedded />}
          />
        </Route>
      ) : (
        <Route
          path="/politique-de-confidentialite"
          element={<PrivacyPolicyPage />}
        />
      )}
      <Route
        element={
          <AuthRoute isAuthenticated={isAuthenticated} isLoading={isLoading} />
        }
      >
        <Route path="/inscription" element={<SignUp />} />
        <Route path="/completer-mon-profil" element={<SocialAuth />} />
        <Route path="/login" element={<Login />} />
        <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
      </Route>
      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuthenticated}
            isLoading={isLoading}
            user={user}
            isProfile={true}
          />
        }
      >
        <Route element={<MainLayout user={user} />}>
          <Route path="centre-aide" element={<PageAide />} />

          <Route path="verification" element={<Verif />} />
          <Route path="verifier" element={<Navigate to="/verification" replace />} />
          <Route path="mon-profil" element={<ProfilePage />} />
          <Route path="mon-compte" element={<ModifProfilePage />} />

          <Route path="changer-mot-de-passe" element={<PasswordPage />} />
          <Route path="parametres-du-compte" element={<AccountSettingPage />} />
          <Route
            path="conditions-generales"
            element={<GeneralConditionPage />}
          />
        </Route>
      </Route>
      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuthenticated}
            isLoading={isLoading}
            user={user}
            isProfile={false}
          />
        }
      >
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="erreur-400" element={<Error400 />} />
        <Route path="erreur-403" element={<Error403 />} />
        <Route path="erreur-404" element={<Error404 />} />
        <Route
          path="erreur-404"
          element={<Navigate to="/erreur-404" replace />}
        />
        <Route path="erreur-500" element={<Error500 />} />
        <Route path="erreur-503" element={<Error503 />} />
        <Route element={<MainLayout user={user} />}>
          <Route path="reclamation/:id" element={<TicketPage />} />
          {user.selectedRole === userRoleList.CLIENT ? (
            <>
              <Route path="deposer-une-annonce" element={<AnnonceStepper />} />
              <Route
                path="annonce/modifier-annonce/:id"
                element={<PageUpdateAnnonce />}
              />
              <Route path="prestataires" element={<RecherchePrestataires />} />
              <Route path="paiement" element={<PaymentPage />}>
                <Route
                  path=":id"
                  element={<PaymentSheet intervention={false} />}
                />
                <Route path="confirmer" element={<CompletePage />} />
              </Route>
              <Route
                path="intervention/paiement"
                element={<InterventionPaymentPage />}
              >
                <Route
                  path=":id"
                  element={<PaymentSheet intervention={true} />}
                />
                <Route
                  path="confirmer/:id"
                  element={<CompletePage intervention={true} />}
                />
              </Route>
              <Route element={<ClientContainer />}>
                <Route path="notifications" element={<NotificationPage />} />
                <Route
                  path="reclamations"
                  element={<TicketsPage user={user} />}
                />
              </Route>
              {clientAllroutes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`${data.url}`}
                  element={data.component}
                />
              ))}
              <Route path="*" element={<Navigate to="/erreur-404" replace />} />
            </>
          ) : (
            <>
              <Route path="paiement" element={<BancDetails />} />
              <Route element={<TechContainer />}>
                <Route path="notifications" element={<NotificationPage />} />
                <Route
                  path="reclamations"
                  element={<TicketsPage user={user} />}
                />
              </Route>
              {Techallroutes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`${data.url}`}
                  element={data.component}
                />
              ))}
              <Route path="*" element={<Navigate to="/erreur-404" replace />} />
            </>
          )}
        </Route>
      </Route>
    </Routes>
  );
};
const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
    isLoading: isLoading(state),
    user: getUser(state),
  };
};
export default connect(mapStateToProps)(RouterComponent);
